var DateNoTz = require('./DateNoTz');

// This file can be moved to a more appropriate location later on 
class EntitlementDetail{
    constructor(constructorObject, restrictEntitlementTable = false){
        for(var key in constructorObject){
            this[key] = constructorObject[key];
        }

        this.restrictEntitlementTable = restrictEntitlementTable;
        this.defaultIdDescriptor = "entitlement_setting_id"; // for self
    }

    get startDate(){
        if(this.entitlementStartDate){
            return new Date(this.entitlementStartDate);
        }
        else{
            return new Date();
        }
    }
    get endDate(){
        if(this.entitlementEndDate){
            return new Date(this.entitlementEndDate);
        }
        else{
            return new Date();
        }
    }
    get name(){
        return this.entitlementType;
    }
    get entitled() {
        if(this.restrictEntitlementTable) {
            return parseInt(this.initialEntitlements);
        }

        return parseInt(this.entitlementsCredited) + parseInt(this.initialEntitlements);
    }

    get used(){
        return this.entitlementsClaimed;
    }
    get remaining(){
        return this.entitlementsRemaining;
    }
    
    get type(){
        var type = null;
        if(this.entitlementType){
            type = this.entitlementType.substring(0,4).toLowerCase();
        }
        return type;
    }

    isFoundInEntitlementGroups(entitlementGroups =[]){
        for (let i = 0; i < entitlementGroups.length; i++) {
            const entitlementGroup = entitlementGroups[i];
            if(this.entitlementType && entitlementGroup.api_value &&
                this.entitlementType.toLowerCase() == entitlementGroup.api_value.toLowerCase()){
                this.entitlementGroupName = entitlementGroup.entitlement_group_name
                    return true;
            }
        }
        return false;
    }
    isEntitlementValid(dateNowString){
        var dateNow = new DateNoTz(dateNowString)
        var nowTime = dateNow.convertToSeconds()

        var startDate = new DateNoTz(this.entitlementStartDate)
        startDate.setTime("00:00:00")
        var startTime = startDate.convertToSeconds()

        // var endDate = new DateNoTz(this.entitlementEndDate)
        var endDate = new DateNoTz(this.entitlementEndDate)
        endDate.setTime("23:59:59")
        var endTime = endDate.convertToSeconds()
        return startTime <= nowTime && nowTime <= endTime;
    }
}

module.exports = EntitlementDetail;